import { getCarouselChartInfo } from "@/apis/user";
import { CarouselType } from "@/entities/Carousel"
import { create } from "zustand";

type CarouselStore = {
    carousels: CarouselType[],
    getCarousels: () => Promise<any>;
}

export const useCarouselStore = create<CarouselStore>((set) => {
    return {
        carousels: [],
        getCarousels: async () => {
            const res = await getCarouselChartInfo();
            if(res && res.data){
                set({
                    carousels:res.data || [],
                })
            }
            
        } 
    }
})